import {
  USER_POPUP_FETCH_STARTED,
  USER_POPUP_FETCH_SUCCEEDED,
  USER_POPUP_FETCH_FAILED,
  USER_POPUP_CHANGE_PAGE,
  USER_POPUP_SET_FILTER,
  USER_POPUP_OPEN_POPUP,
  USER_POPUP_CLEAR
} from '#action/types';
import { getUsersWithRootProjects } from '#component/user/dashboard/helper';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  users: null,
  project: null,
  error: null,
  page: 1,
  itemsPerPage: 50,
  order: 'asc',
  orderBy: 'firstName',
  pages: 0,
  filter: null,
  filterBy: ['fullName', 'project'],
  isOpen: false
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case USER_POPUP_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case USER_POPUP_FETCH_SUCCEEDED:
      const { users, projects, totalCount } = action.payload;
      return {
        ...state,
        status: statuses.succeeded,
        users: getUsersWithRootProjects(users, projects, []),
        pages: Math.ceil(totalCount / state.itemsPerPage),
        totalCount
      };
    case USER_POPUP_FETCH_FAILED:
      return { ...state, status: statuses.failed, users: [], error: action.error };
    case USER_POPUP_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case USER_POPUP_SET_FILTER:
      return { ...state, filter: action.payload };
    case USER_POPUP_OPEN_POPUP: {
      return { ...state, isOpen: action.payload };
    }
    case USER_POPUP_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
